import http from '../httpService';
import axios from 'axios';
import {BASE_URL, token} from '../../utils/const';
export function getAllProcesses() {
  return http.get('/processes?active.equals=true');
}

export function getAllSubProcesses(processId) {
  return http.get(`/subprocesses?processId.equals=${processId}&active.equals=true`);
}

export function getAllDepartments() {
  return http.get('/departments');
}

export function getAllRiskTypes() {
  return http.get('/risk-types');
}

// export function getReport(){
//   return http.get(`reports/risks/risk-report-measures`)
// }

export const getReport = (api, criteria, isCustom, customApi) => {
  let url = `${BASE_URL}/${api}${isCustom ? '&' : '?'}${criteria}`;
  if (customApi) {
    url = `${BASE_URL}/${api}&${criteria}`;
  }
  return axios({
    method: 'GET',
    url: url,
    responseType: 'blob',
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
  });
};

export const getReportErr = (api, criteria, customApi) => {
  let url = `${BASE_URL}/${api}?${criteria}`;
  if (customApi) {
    url = `${BASE_URL}/${api}&${criteria}`;
  }
  return axios({
    method: 'GET',
    url: url,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
};

export const getTableReport = (api, userId, criteria, pageNumber) => {
  return axios({
    method: 'GET',
    url: `${BASE_URL}/${api}/${userId}?page=${pageNumber}&size=20${criteria}`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
}

export function sendStatement(dateStart,dateEnd,departmentId){
  return http.put(`risks/month-report?departmentId=${departmentId}&dateStart=${dateStart}&dateEnd=${dateEnd}`)
}